var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0001 37.1999C58.8216 38.2067 55.4369 38.75 51.925 38.75C33.5201 38.75 18.6001 23.8297 18.6001 5.42499C18.6001 3.57762 18.7504 1.76537 19.0394 -6.86646e-05H39.7453C39.0062 1.65709 38.5952 3.49296 38.5952 5.42499C38.5952 12.7869 44.5631 18.755 51.925 18.755C55.9488 18.755 59.5559 16.9722 62.0001 14.1535V37.1999Z",
    fill: "#2A27C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27002 62C4.81209 48.0501 16.6389 37.1999 30.9998 37.1999C45.3605 37.1999 57.1874 48.0501 58.7294 62H38.7768C37.545 58.9121 34.5271 56.73 30.9998 56.73C27.4723 56.73 24.4546 58.9121 23.2226 62H3.27002Z",
    fill: "#EA6CBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame2.2845a6520d6fc5568a12769637eb1d3f.svg";
export { ForwardRef as ReactComponent };